import * as React from 'react';
import { ComponentClass } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Theme, WithStyles } from "@material-ui/core";
import { bindActions, mockTheme, WithActions } from '../utils/utils';
import { IStore } from '../store';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { RouteData } from '../components/routeSelector';
import RaceAdd, { RaceAbmState } from '../components/race/raceAdd';

import { RaceActions } from '../store/race/race-actions';
import Paper from '@material-ui/core/Paper';
import { IRaceStore } from '../store/race/race-reducer';
import { AddRaceDTO } from '../api/model';
import { ConfigData } from '../config';


const styles = (theme: Theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: `calc(50% - ${theme.spacing.unit * 3}px)`,
    },
    menu: {
        width: 200,
    },

    add: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },

    routeSelector: {
        width: '100%',
        height: '100%'
    },
    buttons: {
        marginLeft: 'auto',
    }
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

interface RacesProps extends WithStyles<keyof typeof classesType>, WithActions<RaceActions> {
    race: IRaceStore;
    config: ConfigData;
}

interface RacesState {
    abmState: RaceAbmState
}

class Races extends React.Component<RacesProps, RacesState> {

    constructor(props: RacesProps) {
        super(props);

        this.state = {
            abmState: 'edit'
        };

        this.handleNewLocation = this.handleNewLocation.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleNewLocation(data: RouteData) {
        this.setState({
            ...this.state,
        })
    }

    handleSubmit(data: AddRaceDTO) {
        console.log('adding new route');
        this.setState({
            abmState: 'adding',
        });
        this.props.actions.add(data);
    }

    componentWillReceiveProps(nextProps: RacesProps) {
        console.log('new props', nextProps.race.current);
        if (nextProps.race.current.data && nextProps.race.current.data.type) {
            this.setState({
                abmState: 'added',
            })
        }
        if (nextProps.race.current.error) {
            this.setState({
                abmState: 'error',
            })
        }
    }


    render() {

        return (
            <Grid container spacing={24}>
                <Grid item md={12} lg={12}>
                    <Paper elevation={11} className={this.props.classes.add}>
                        <Typography variant="title">Agregar Carrera</Typography>
                        <RaceAdd handleAdd={this.handleSubmit}
                            error={this.props.race.current.error}
                            state={this.state.abmState}
                            config={this.props.config}
                        />
                    </Paper>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: RacesProps) => ({
    ...ownProps,
    race: state.race,
    config: state.config.data
});


const styled = withStyles(styles as any)(Races);
const connected = connect(mapStateToProps, bindActions(RaceActions))(styled);

export default connected as ComponentClass<Partial<RacesProps>>;



// WEBPACK FOOTER //
// ./src/pages/races.tsx